import { useEffect, useState } from 'react'

import TitledContainer from 'components/ui/TitledContainer/TitledContainer'
import { Button } from 'components/ui/Button/Button'
import { Slider } from 'components/ui/Slider/Slider'
import { WarehouseSearch } from 'components/WarehouseSearch/WarehouseSearch'
import { Warehouse, WarehouseType } from 'services/warehouse-containers/warehouse'
import { useContainersActions } from 'services/warehouse-containers/containers'
import { QrPaste } from 'components/QrPaste/QrPaste'
import { QrEntry } from 'components/QrPaste/types'
import { Toggle } from 'components/ui/Toggle/Toggle'
import { IDPaste } from 'components/IDPaste/IDPaste'

import '../Cargo/cargo.style.css'

export const MoveContainers = () => {
  const [entries, setEntries] = useState<QrEntry[]>([])
  const [isSliderActive, setIsSliderActive] = useState(false)
  const [warehouse, setWarehouse] = useState<Warehouse | null>(null)
  const [formKey, setFormKey] = useState(0)
  const [toggled, setToggled] = useState<boolean>(false)
  const [texts, setTexts] = useState<{ hint: string; placeholder: string }>()

  const { transferContainers, isLoading } = useContainersActions()

  const changeText = () => {
    const textToggleA = 'Режим: QR - фото'
    const textToggleB = 'Режим: вставка ID'

    const hintA = 'Скопируйте изображение QR-кода в буфер, кликните в зону и вставьте.'
    const hintB = 'Вставьте id контейнеров в формате <uuid>\\n'

    if (toggled) {
      setTexts({ hint: hintB, placeholder: textToggleB })
      return
    }

    setTexts({ hint: hintA, placeholder: textToggleA })
  }

  useEffect(() => {
    changeText()
  }, [toggled])

  const closeSlider = () => setIsSliderActive(false)

  const reset = () => {
    setEntries([])
    setWarehouse(null)
    // NOTE: Вот это сильно смущает. Но не понятно как нам сбросить WarehoseSearch и при этом не
    // ререндерить всю страницу. У нас так везде и работает.
    setFormKey((key) => key + 1)
    closeSlider()
  }

  const handleMove = async () => {
    if (!warehouse || entries.length === 0) return

    const ok = await transferContainers(
      warehouse.id,
      entries.map((entry) => entry.containerId)
    )

    if (!ok) {
      closeSlider()

      return
    }

    reset()
  }

  const handleToggle = (value: boolean) => {
    setToggled(value)
    setEntries([])
  }

  const handleOnChange = (containerIDs: string[]) => {
    const result: QrEntry[] = containerIDs.map<QrEntry>((value) => ({ containerId: value }))

    setEntries(result)
  }

  return (
    <>
      <TitledContainer title="Перемещение контейнеров между складами" hint={texts?.hint}>
        <span style={{ paddingBottom: '3px' }}>
          <Toggle onChange={handleToggle} checked={toggled} name={texts?.placeholder} />
        </span>
        {toggled ? (
          <IDPaste onChange={handleOnChange} value={null} />
        ) : (
          <QrPaste entries={entries} onChange={setEntries} withSeal={false} />
        )}
        <div className="create-cargo__submit-row">
          <Button
            title="Переместить"
            disabled={entries.length === 0 || entries.some((entry) => !entry.containerId)}
            handleOnSubmit={() => setIsSliderActive(true)}
          />
        </div>
      </TitledContainer>
      <Slider isActive={isSliderActive} onClose={closeSlider} height="360px">
        <div className="transfer-page-list__slider">
          <h2>Перемещение контейнеров</h2>
          <div className="support-transfer__slider-target">
            <label className="create-cargo__field-label">Склад назначения</label>
            <WarehouseSearch
              key={formKey}
              onSelect={setWarehouse}
              searchForTypes={[
                WarehouseType.MiniWarehouse,
                WarehouseType.Courier,
                WarehouseType.MobileWarehouse,
              ]}
            />
          </div>
          <div className="transfer-page-list__slider-controlls">
            <span className="create-cargo__action-gap">
              <Button
                title="Переместить"
                disabled={!warehouse || isLoading}
                isLoading={isLoading}
                handleOnSubmit={handleMove}
              />
            </span>
            <Button outline title="Отмена" handleOnSubmit={closeSlider} />
          </div>
        </div>
      </Slider>
    </>
  )
}
